<ion-grid >
    <ion-row class="header">
        <ion-col *ngIf="productCode">
            <span>Are you sure you want to delete {{productCode}} from the {{tableName}} Table?</span>
        </ion-col>
        <ion-col *ngIf="workOrder">
            <span>{{workOrder}}</span>
        </ion-col>
    </ion-row>
    <ion-row class="button-row">
        <ion-col>
            <ion-button class="confirm" (click)="close(true)">
                Confirm
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button class="cancel" (click)="close(false)">
                Cancel
            </ion-button>
        </ion-col>
    </ion-row>
</ion-grid>